import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderFlowmonPartners extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices);
    this.patnerTypesTaxonId = '94bb48a6-d944-4834-9cf4-1196dbf61e77';
  }

  getItemHtml(item, relatedMedia) {

      const img  = (item.Logo) ?  item.Logo.Url : '';
      const countryData = item.countryData.map(country=> country.Title).join(', ');
      const partnerURL = `https://kemptechnologies.com/kemp-partner/${item.UrlName}`

      const data = {
        Email: item.Email,
        Address: `${item.Thoroughfare} ${item.Premise} ${item.State} ${item.PostalCode} ${item.Locality} ${countryData}`,
        Country: countryData,
        Phone: item.Phone,
        Website: `<a href="${item.Website}" target="_blank">${item.Website}</a>`,
        Type: item.partnerType.find(type=> type.ParentId === this.patnerTypesTaxonId) || 'No partner type'
      };

      let partnerTable = '';

      for (const [key, value] of Object.entries(data)) {
        if (value.length > 0) {
          partnerTable += `
            <tr>
              <th>${key}</th>
              <td>${value}</td>
            </tr>`;
        }
      }

      const html = `
      <div class="Card Elevated PartnerItem">
        <div>
          <div class="row">
            <div class="col-4">
              <a href="${partnerURL}">
                <img src="${img}" class="PartnerLogo"/>
              </a>
            </div>
            <div class="col-8">
              <a href="${partnerURL}" class="Link">
                ${this.encodeHtml(item.Title)}
              </a>
              <table>
                `+ partnerTable +`
              </table>
            </div>
          </div>
        </div>
      </div>
    `;
    return html;

  }
}
